angular.
module("dx.webapp.jobs", [
	"dx.webapp.api",
	"dx.webapp.navigation",
]);
